import { render, staticRenderFns } from "./RDCCandidate.vue?vue&type=template&id=9f57c19e"
import script from "./RDCCandidate.vue?vue&type=script&lang=js"
export * from "./RDCCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports